/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Block, ErrorMessage } from '@atoms';
import { TextField } from '@molecules';
import { Form } from '@organisms';

import MediaField from '../MediaField';

import { FORM_FIELD } from './constants';

const TITLE_STYLE = {
  fontWeight: 800,
  fontSize: 22,
  lineHeight: '170%',
};

const AthleteForm = ({ initialValues = {}, error, form, athleteName }) => {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <h1 style={TITLE_STYLE}>{athleteName}</h1>
        <MediaField {...FORM_FIELD.ATHLETE_IMAGE} />
        <TextField {...FORM_FIELD.TWITTER} />
        <TextField {...FORM_FIELD.FACEBOOK} />
        <TextField {...FORM_FIELD.INSTAGRAM} />
      </Block>
    </Form>
  );
};

AthleteForm.useForm = () => Form.useForm(FORM_FIELD);

export default AthleteForm;
